var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { PREDICTIVE_SEARCH } from '../graphql/predictiveSearch';
import ShopifyAjaxApi from '@themes/common/shopifyApi';
export const usePredictiveSearch = () => {
    const fetchPredictiveSearch = useCallback((query, types, limit = 10) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            const response = yield ShopifyAjaxApi.StorefrontQuery(PREDICTIVE_SEARCH, {
                query,
                types: types || ['PRODUCT', 'COLLECTION', 'PAGE', 'ARTICLE', 'QUERY'],
                limit,
            });
            const result = ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.predictiveSearch) ||
                {
                    products: [],
                    collections: [],
                    pages: [],
                    articles: [],
                    queries: [],
                };
            // Exclude products that have the tag "hidden" (case-insensitive)
            const filteredProducts = (result.products || []).filter((p) => { var _a; return !((_a = p.tags) === null || _a === void 0 ? void 0 : _a.some((t) => t.toLowerCase() === 'hidden')); });
            // Exclude collections/pages/articles marked hidden via metafield custom.hidden == truthy
            const isHiddenMeta = (m) => {
                var _a;
                const v = ((_a = m === null || m === void 0 ? void 0 : m.value) !== null && _a !== void 0 ? _a : '').toString().trim().toLowerCase();
                return v === 'true' || v === '1' || v === 'yes' || v === 'hidden';
            };
            const filteredCollections = (result.collections || []).filter((c) => !isHiddenMeta(c.metafield));
            const filteredPages = (result.pages || []).filter((p) => !isHiddenMeta(p.metafield));
            // Exclude articles with tag "hidden" or metafield custom.hidden truthy
            const filteredArticles = (result.articles || []).filter((a) => {
                const hasHiddenTag = Array.isArray(a.tags) && a.tags.some((t) => { var _a; return ((_a = t === null || t === void 0 ? void 0 : t.toLowerCase) === null || _a === void 0 ? void 0 : _a.call(t)) === 'hidden'; });
                return !hasHiddenTag && !isHiddenMeta(a.metafield);
            });
            return Object.assign(Object.assign({}, result), { products: filteredProducts, collections: filteredCollections, pages: filteredPages, articles: filteredArticles });
        }
        catch (error) {
            // Return empty results on error
            return {
                products: [],
                collections: [],
                pages: [],
                articles: [],
                queries: [],
            };
        }
    }), []);
    return { fetchPredictiveSearch };
};
